import React, { useState } from 'react';
import XLSX from 'xlsx';
import Functions from '../../api/Functions';
import { Redirect } from 'react-router-dom';

const SheetJSFT = ['xlsx', 'xlsb', 'xlsm', 'xls', 'xml']
  .map(function (x) {
    return '.' + x;
  })
  .join(',');

function NewLevels() {
  const [file, setFile] = useState(null);
  const [updateCompleted, setUpdateCompleted] = useState(false);
  const [updateFailed, setUpdateFailed] = useState(false);
  const [showSelectFile, setShowSelectFile] = useState(false);

  const handleChange = (e) => {
    const files = e.target.files;
    if (files && files[0]) {
      setFile(files[0]);
    }
  };

  const handleFile = () => {
    if (file != null) {
      const reader = new FileReader();
      const rABS = !!reader.readAsBinaryString;

      reader.onload = (evt) => {
        const bstr = evt.target.result;
        //TODO refactor XLSXUtil
        const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA: true });

        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];

        const dataXls = XLSX.utils.sheet_to_json(ws);
        const levelsXls = JSON.parse(JSON.stringify(dataXls, null, 2));

        let previousLevel = null;
        const newLevels = levelsXls.map((level) => {
          const newLevel = {
            name: level['Levels'],
            minXp: previousLevel ? previousLevel['XP Needed'] + 1 : 0,
            maxXp: level['XP Needed'],
          };
          previousLevel = level;
          return newLevel;
        });

        const lastLevel = {
          name: newLevels.length + 1,
          minXp: previousLevel ? previousLevel['XP Needed'] + 1 : 0,
          maxXp: 150000,
        };
        newLevels.push(lastLevel);
        console.log('New Levels', newLevels);

        Functions.readjustLevels(newLevels)
          .then((result) => {
            console.log('result', result);
            setUpdateCompleted(true);
          })
          .catch((e) => {
            console.log('error', e.message);
            setUpdateFailed(true);
          });
      };

      if (rABS) {
        reader.readAsBinaryString(file);
      } else {
        reader.readAsArrayBuffer(file);
      }
    } else {
      setShowSelectFile(true);
    }
  };

  if (updateCompleted) return <Redirect to="/levels" />;

  return (
    <div className="container">
      <label htmlFor="file">Enter the excel file for level update</label>
      <br />
      <input type="file" className="form-control" id="file" accept={SheetJSFT} onChange={handleChange} />
      <br />
      <input type="submit" value="Update levels" onClick={handleFile} />
      <br />
      {showSelectFile && <h5 className="red-text">Select File</h5>}
      {updateFailed && <h5 className="red-text">Failed to update, check data in .xlsx file</h5>}
    </div>
  );
}

export default NewLevels;
